import { FormEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PepLogo } from "../components/brand/PepLogo";
import { SeoHead } from "../components/seo/SeoHead";
import { fetchPepSettings, setAdminKey } from "./admin-api";

export function AdminLoginPage() {
  const navigate = useNavigate();
  const [key, setKey] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    setAdminKey(key.trim());
    try {
      await fetchPepSettings();
      navigate("/admin/leads", { replace: true });
    } catch {
      setError("Clé admin invalide ou API indisponible.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center bg-body-tertiary p-3">
      <SeoHead
        title="Admin PEP"
        description="Espace d'administration privé du Product Experience Platform."
        canonicalPath="/admin/login"
        noIndex
      />
      <div className="card border-0 shadow-sm p-4" style={{ maxWidth: 420, width: "100%" }}>
        <div className="mb-4">
          <PepLogo variant="compact" />
        </div>
        <h1 className="h5 fw-bold mb-2">Super Admin PEP</h1>
        <p className="text-secondary small mb-4">
          Consultez les devis, démos et essais. Configurez les notifications (email aujourd&apos;hui,
          tickets CRM demain).
        </p>
        <form onSubmit={onSubmit}>
          <label className="form-label">Clé d&apos;accès admin</label>
          <input
            type="password"
            className="form-control mb-3"
            value={key}
            onChange={(e) => setKey(e.target.value)}
            placeholder="PEP_ADMIN_API_KEY"
            required
            autoComplete="current-password"
          />
          {error && <div className="alert alert-danger py-2 small">{error}</div>}
          <button type="submit" className="btn btn-primary w-100" disabled={loading}>
            {loading ? "Connexion…" : "Accéder"}
          </button>
        </form>
        <p className="text-secondary small mt-3 mb-0">
          En dev sans variable d&apos;environnement : utilisez <code>dev-admin</code>.
        </p>
      </div>
    </div>
  );
}
